export { default as closeFlexPane } from './flexpanes/closeFlexPane';
export { default as openFlexPane } from './flexpanes/openFlexPane';
export { default as setSearchActive } from './theme/setSearchActive';
export { showO365ShellHeader } from './utils/showO365ShellHeader';
